import VueCamera from './VueCamera.vue'
export default VueCamera
